export const getTaskById = (id, tasksList = []) => tasksList.filter(task => task.taskId === id);